export const COPYRIGHT_NOTICE = "© 2026 Roberto Veri – EVOSOFT, tutti i diritti riservati";
